import type { CaseRecord } from '../types'

export const normalize = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()

const distance = (a: string, b: string) => {
  const row = Array.from({ length: b.length + 1 }, (_, index) => index)
  for (let i = 1; i <= a.length; i += 1) {
    let previous = row[0]
    row[0] = i
    for (let j = 1; j <= b.length; j += 1) {
      const current = row[j]
      row[j] = Math.min(row[j] + 1, row[j - 1] + 1, previous + (a[i - 1] === b[j - 1] ? 0 : 1))
      previous = current
    }
  }
  return row[b.length]
}

export const fuzzyIncludes = (haystack: string, needle: string) => {
  const normalizedHaystack = normalize(haystack)
  const normalizedNeedle = normalize(needle)
  if (!normalizedNeedle || normalizedHaystack.includes(normalizedNeedle)) return true
  if (normalizedNeedle.length < 4) return false
  return normalizedHaystack.split(/\s+/).some((word) => Math.abs(word.length - normalizedNeedle.length) <= 2 && distance(word, normalizedNeedle) <= 2)
}

const caseSearchText = (record: CaseRecord) => [
  record.title, record.dek, record.summary30s, record.tags.join(' '), record.peopleIds.join(' '), record.institutionIds.join(' '),
  record.editorialReading.headline, record.editorialReading.summary,
  record.editorialReading.points.flatMap((point) => [point.title, point.analysis]).join(' '),
  record.dailyImpact.headline, record.dailyImpact.summary, record.dailyImpact.areas.join(' '),
  record.processDecided, record.processDidNotDecide, record.openQuestions.join(' '),
  record.investigation?.searchTerms.join(' '), record.investigation?.network?.nodes.map(node => node.name).join(' '),
].join(' ')

export const searchCases = (records: CaseRecord[], query: string) => {
  const term = normalize(query)
  return records.map(record => ({ record, text: normalize(caseSearchText(record)) }))
    .filter(({ text }) => fuzzyIncludes(text, query))
    .sort((a, b) => Number(b.text.includes(term)) - Number(a.text.includes(term)) || Number(normalize(`${b.record.title} ${b.record.shortTitle}`).includes(term)) - Number(normalize(`${a.record.title} ${a.record.shortTitle}`).includes(term)))
    .map(({ record }) => record)
}
